import { getDataAPI, postDataAPI, getBlobDataAPI } from "../../../helper/api";

export const requestPlaceCall = (payload) => {
  return postDataAPI(`/api/AiVerificationCall/PlaceCall`, { ...payload });
};

export const requestGetCallStatus = (jobId) => {
  return getDataAPI(`/api/AiVerificationCall/Status/${jobId}`);
};

export const requestEndCall = (jobId) => {
  return postDataAPI(`/api/AiVerificationCall/${jobId}/EndCall`, {});
};

export const requestGetRecording = (jobId) => {
  return getBlobDataAPI(`/api/AiVerificationCall/Recording/${jobId}`);
};

export const requestGetJobs = () => {
  return getDataAPI(`/api/AiVerificationCall/Jobs`);
};

export const requestGetDoctorLogs = (phoneNumber) => {
  // CONFIRMED via real Swagger testing: a leading "+" in this URL's path
  // segment gets blocked by IIS request filtering before it ever reaches
  // the backend (404, generic IIS page — not a real API error). Bare
  // digits (no "+") work correctly, since the backend normalizes and
  // matches the number internally either way. Stripping it here is the
  // safe fix, on the frontend side, rather than a backend/routing change.
  const phoneForUrl = (phoneNumber || "").replace(/^\+/, "");
  return getDataAPI(
    `/api/AiVerificationCall/DoctorLogs/${encodeURIComponent(phoneForUrl)}`
  );
};

export const requestGetBillingLogs = () => {
  return getDataAPI(`/api/AiVerificationCall/BillingLogs`);
};

export const requestImportCall = (payload) => {
  const { vapiCallId, doctorName, phoneNumberOverride } = payload;
  const query = `?doctorName=${encodeURIComponent(
    doctorName || ""
  )}&phoneNumberOverride=${encodeURIComponent(phoneNumberOverride || "")}`;
  return postDataAPI(`/api/AiVerificationCall/Import/${vapiCallId}${query}`, {});
};

export const requestGetTranscript = (jobId) => {
  return getDataAPI(`/api/AiVerificationCall/Transcript/${jobId}`);
};